import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import FormField from '../../../../../dynamicFormBuilder/FormField'


function CommonTab(props) {
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    

    const handleAdditionalFormLoad = useCallback(() => {
      //  props.additionalFormLookupsLoad();

    }, []);
    const handleFieldChange = useCallback((name,val,e) => {
      //  props.additionalFormLookupsLoad();

    }, []);
    return (
        <div style={{marginTop:"10px"}}>
            <FormField
                currrentUser={currentUser}
                layoutId='0A80C63F-4963-4BFF-AF63-056B07BF196A'
                layoutName='WMTransSetupForm'
                defaultFormSchema={props.formSchema}
                formFields={props.formFields}
                setformFields={props.setformFields}
                handleFieldValueChange={handleFieldChange}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={props.formRefs}
                onFormLoad={handleAdditionalFormLoad}
                handleSelectedItemChange={props.handleSelectionChange}
            />

        </div>
    );
}
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(CommonTab);
